import { capitalizeEachWord } from '../util/Etc';
import { longRecruitName } from '../components/LongRecruitName';

export function firstInitialLastName(recruit) {
  const { firstName, lastName } = recruit;
  let output = '';

  if (firstName && lastName) {
    output = `${firstName[ 0 ]}. ${lastName}`;
  } else if (firstName) {
    output = firstName;
  } else if (lastName) {
    output = lastName;
  }

  return capitalizeEachWord(output);
}

export function lastNameFirstName(recruit) {
  const { firstName, lastName } = recruit;
  let output = '';

  if (firstName && lastName) {
    output = `${lastName}, ${firstName}`;
  } else if (firstName) {
    output = firstName;
  } else if (lastName) {
    output = lastName;
  }

  return output;
}

export function nameYearClubTeam(recruit) {
  const { firstName, lastName, year, clubTeam } = recruit;
  let output = '';

  // Add name to output
  if (firstName || lastName) {
    output += longRecruitName(recruit);
  }

  if (year || clubTeam) {
    output += ' (';

    if (year && clubTeam) {
      output += `${year}, ${clubTeam}`;
    } else {
      output += year || clubTeam;
    }

    output += ')';
  }

  return output;
}

export default {
  firstInitialLastName,
  lastNameFirstName,
  nameYearClubTeam
};



// WEBPACK FOOTER //
// ./src/js/filters/RecruitFilters.js